<wdm-list-workflow-table *ngIf="viewListWorkFlow"></wdm-list-workflow-table>

<router-outlet></router-outlet>
